<template>
  <div>
    <span>Профиль</span>
    <br />
    <span>
      <a class="indigo-text text-lighten-1">Ваши данные и настройки</a>
    </span>

    <hr />
    <br />

    <div>
      <p class="indigo-text text-lighten-1">Имя</p>
      <h6>{{user.name || "-"}}</h6>

        <div v-if="doChangeName" class="input-field">
          <input
            id="newName"
            type="text"
            v-model.trim="newName"
            :class="{invalid: $v.newName.$dirty && !$v.newName.required}"
          />
          <label for="newName">Новое имя</label>
          <small
            class="helper-text invalid"
            v-if="$v.newName.$dirty && !$v.newName.required"
          >Введите имя</small>
          <small
            class="helper-text invalid"
            v-if="getMessages()"
          >{{getMessages()}}</small>
        </div>      

      <div class="valign-wrapper section"> 
        <span v-if="doChangeName" style="padding: 0px 20px 0px 0px">
          <a v-on:click.prevent="submitChangeName()">
            <button class="waves-effect waves-light btn-flat btn-small indigo white-text">
              Изменить
              <i class="material-icons right">send</i>
            </button>
          </a>
        </span>

        <span style="padding: 0px 0px 0px 0px">
          <a v-on:click.prevent="changeOff('name')">
            <a
              v-if="!doChangeName"
              class="waves-effect waves-light btn-flat btn-small indigo lighten-5"
            >Сменить</a>
            <a
              v-if="doChangeName"
              class="waves-effect waves-light btn-flat btn-small indigo lighten-5"
            >Отмена</a>
          </a>
        </span>
      </div>



      <div class="divider"></div>

      <p class="indigo-text text-lighten-1">Email</p>
       <h6>{{user.email || "-"}}</h6>

        <div v-if="doChangeEmail" class="input-field">
          <input
            id="newEmail"
            type="text"
            v-model.trim="newEmail"
            :class="{invalid: ($v.newEmail.$dirty && !$v.newEmail.required) || ($v.newEmail.$dirty && !$v.newEmail.email)}"
          />
          <label for="newEmail">Новый email</label>
          <small
            class="helper-text invalid"
            v-if="$v.newEmail.$dirty && !$v.newEmail.required"
          >Некорректный email</small>
          <small
            class="helper-text invalid"
            v-if="getMessages()"
          >{{getMessages()}}</small>
        </div>

      <div class="valign-wrapper section">
        <span v-if="doChangeEmail" style="padding: 0px 20px 0px 0px">
          <a v-on:click.prevent="submitChangeEmail()">
            <button class="waves-effect waves-light btn-flat btn-small indigo white-text">
              Изменить
              <i class="material-icons right">send</i>
            </button>
          </a>
        </span>

        <span style="padding: 0px 0px 0px 0px">
          <a v-on:click.prevent="changeOff('email')">
            <a
              v-if="!doChangeEmail"
              class="waves-effect waves-light btn-flat btn-small indigo lighten-5"
            >Сменить</a>
            <a
              v-if="doChangeEmail"
              class="waves-effect waves-light btn-flat btn-small indigo lighten-5"
            >Отмена</a>
          </a>
        </span>
      </div>



      <div class="divider"></div>

      <p class="indigo-text text-lighten-1">Пароль
      <br/>
      (для безопасности пароль хранится в скрытом зашифрованном виде)
      </p>

      <div v-if="doChangePass" class="input-field">
        <input
          id="newPass"
          type="password"
          v-model.trim="newPass"
          :class="{invalid: ($v.newPass.$dirty && !$v.newPass.required) || ($v.newPass.$dirty && !$v.newPass.minLength)}"
        />
        <label for="newPass">Новый пароль</label>
        <small
          class="helper-text invalid"
          v-if="$v.newPass.$dirty && !$v.newPass.required"
        >Введите пароль</small>
        <small
          class="helper-text invalid"
          v-else-if="$v.newPass.$dirty && !$v.newPass.minLength"
        >Пароль должен быть не менее {{$v.newPass.$params.minLength.min}} символов. Сейчас он {{newPass.length}}.</small>
        <small
          class="helper-text invalid"
          v-if="getMessages()"
        >{{getMessages()}}</small>
      </div>
      
      <div class="valign-wrapper section">  
        <span v-if="doChangePass" style="padding: 0px 20px 0px 0px">
          <a v-on:click.prevent="submitChangePass()">
            <button class="waves-effect waves-light btn-flat btn-small indigo white-text">
              Изменить
              <i class="material-icons right">send</i>
            </button>
          </a>
        </span>

        <span style="padding: 0px 0px 0px 0px">
          <a v-on:click.prevent="changeOff('pass')">
            <a
              v-if="!doChangePass"
              class="waves-effect waves-light btn-flat btn-small indigo lighten-5"
            >Сменить</a>
            <a
              v-if="doChangePass"
              class="waves-effect waves-light btn-flat btn-small indigo lighten-5"
            >Отмена</a>
          </a>
        </span>
      </div>
    </div>

  </div>
</template>

<script>
import bcrypt from "bcryptjs/dist/bcrypt.min.js";
import { email, required, minLength } from "vuelidate/lib/validators";

export default {
  name: "profile",
  metaInfo() {
    return {
      title: this.$title("Профиль")
    };
  },
  data: () => ({
    newName: "",
    newEmail: "",
    newPass: "",
    doChangeName: false,
    doChangeEmail: false,
    doChangePass: false
  }),
  computed: {
    user() {
      return this.$store.getters.user;
    },
    server_msg() {
      return this.$store.getters.serverMsg;
    }
  },
  validations: {
    newEmail: { email, required },
    newPass: { required, minLength: minLength(6) },
    newName: { required }
  },
  methods: {
    changeOff(what) {
      switch (what) {
        case "name":
          this.doChangeName = !this.doChangeName;
          this.newName = "";
          this.$v.newName.$reset();
          break;
        case "email":
          this.doChangeEmail = !this.doChangeEmail;
          this.newEmail = "";
          this.$v.newEmail.$reset();
          break;
        case "pass":
          this.doChangePass = !this.doChangePass;
          this.newPass = "";
          this.$v.newPass.$reset();
          break;
      }
    },
    async submitChangeName() {
      if (this.$v.newName.$invalid) {
        this.$v.newName.$touch();
        return;
      }
      await this.$store.dispatch("changeUserData", {
        id: this.user.id,
        name: this.newName
      });
      if (this.server_msg.server_ok) {
        this.changeOff("name");
      }
    },
    async submitChangeEmail() {
      if (this.$v.newEmail.$invalid) {
        this.$v.newEmail.$touch();
        return;
      }
      await this.$store.dispatch("changeUserData", {
        id: this.user.id,
        email: this.newEmail
      });
      if (this.server_msg.server_ok) {
        this.changeOff("email");
      }
    },
    async submitChangePass() {
      if (this.$v.newPass.$invalid) {
        this.$v.newPass.$touch();
        return;
      }
      let that = this;
      bcrypt.genSalt(10, function(err, salt) {
        bcrypt.hash(that.newPass, salt, async function(err, hash) {
          await that.$store.dispatch("changeUserData", {
            id: that.user.id,
            pass: hash
          });
          if (that.server_msg.server_ok) {
            that.changeOff("pass");
          }
        });
      });
    },
    getMessages(){
      return this.$transmsg(this.server_msg.connection_error || this.server_msg.server_error || this.server_msg.server_info);
    }
  }
};
</script>
